import { HttpProvider } from "../http/http.provider";
import { ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHelpDesk, INewHelpDesk, IHelpDeskResponse, INewHelpDeskComment } from "./helpdesk.interface";
import { IHttpRequestConfig } from "../http";

export class HelpDeskDelegate
{
    constructor(private http: HttpProvider)
    {
    }

    public getAllHelpDeskRequest(orgId: string): Observable<IHelpDesk[]>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.HELPDESK.GET_ALL_HELPDESK, null, config).pipe(
            map((response: any) =>
            {
                return response.data.helpDeskRequests;
            }),
            share());
    }

    public createNewHelpDeskRequest(newHelpDesk: INewHelpDesk): Observable<IHelpDeskResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.HELPDESK.CREATE_HELPDESK, newHelpDesk).pipe(
            map((response: any) =>
            {
                return {
                    helpDeskRequests: response.data.helpDeskRequests,
                    id: response.data.helpDeskId
                };
            }),
            share());
    }

    public createComment(comment: INewHelpDeskComment): Observable<IHelpDeskResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.HELPDESK.CREATE_HELPDESK_COMMENT, comment).pipe(
            map((response: any) =>
            {
                return {
                    helpDeskRequests: response.data.helpDeskRequests,
                    id: response.data.helpDeskId
                };
            }),
            share());
    }

    /**
     * Employee self-service variant (formerly in employeeServicelib):
     * lists helpdesk requests for the given employee.
     */
    public getAllHelpDeskRequestByEmployee(employeeId: string): Observable<IHelpDesk[]>
    {
        const config: IHttpRequestConfig = {
            params: {
                EmployeeId: employeeId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.HELPDESK.GET_ALL_HELPDESK_BY_EMPLOYEE, null, config).pipe(
            map((response: any) =>
            {
                return response.data.helpDeskRequests;
            }),
            share());
    }

    /** Employee self-service: create a helpdesk request. */
    public createNewHelpDeskRequestByEmployee(newHelpDesk: INewHelpDesk): Observable<IHelpDeskResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.HELPDESK.CREATE_HELPDESK_BY_EMPLOYEE, newHelpDesk).pipe(
            map((response: any) =>
            {
                return {
                    helpDeskRequests: response.data.helpDeskRequests,
                    id: response.data.helpDeskId
                };
            }),
            share());
    }

    /** Employee self-service: comment on a helpdesk request. */
    public createCommentByEmployee(comment: INewHelpDeskComment): Observable<IHelpDeskResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.HELPDESK.CREATE_HELPDESK_COMMENT_BY_EMPLOYEE, comment).pipe(
            map((response: any) =>
            {
                return {
                    helpDeskRequests: response.data.helpDeskRequests,
                    id: response.data.helpDeskId
                };
            }),
            share());
    }


    public updateHelpDeskRequest(helpDesk: IHelpDesk): Observable<IHelpDesk[]>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.HELPDESK.UPDATE_HELPDESK, helpDesk).pipe(
            map((response: any) =>
            {
                return response.data.helpDeskRequests;
            }),
            share());
    }
}